import { useEffect, useState } from 'react';

import { matchPath, useLocation } from 'react-router-dom';

import Breadcrumbs from 'components/Breadcrumbs/Breadcrumbs';

const QuizBreadcrumbs = () => {
  const { pathname } = useLocation();
  const [finalBreadcrumbs, setFinalBreadcrumbs] = useState([]);
  useEffect(() => {
    let breadcrumbs = [
      {
        title: 'Quizzes',
        link: '/quiz',
      },
    ];
    if (pathname === '/quiz/new') {
      breadcrumbs = [...breadcrumbs, { title: 'Add quiz', link: '' }];
    }
    if (pathname.startsWith('/quiz/edit/')) {
      breadcrumbs = [...breadcrumbs, { title: 'Edit quiz', link: '' }];
    }
    if (pathname.startsWith('/quiz/questions/new/')) {
      const { params } = matchPath<{ questionType: string; quizId: string }>(
        pathname,
        '/quiz/questions/new/:questionType/:quizId'
      );
      const addBreadcrumbs = [
        {
          title: 'Edit quiz',
          link: `/quiz/edit/${params.quizId}`,
        },
        {
          title: 'Add question',
          link: '',
        },
      ];
      breadcrumbs = [...breadcrumbs, ...addBreadcrumbs];
    }
    if (pathname.startsWith('/quiz/questions/edit/')) {
      const { params } = matchPath<{ questionType: string; quizId: string }>(
        pathname,
        '/quiz/questions/edit/:questionType/:questionId/:quizId'
      );
      const addBreadcrumbs = [
        {
          title: 'Edit quiz',
          link: `/quiz/edit/${params.quizId}`,
        },
        {
          title: 'Edit question',
          link: '',
        },
      ];
      breadcrumbs = [...breadcrumbs, ...addBreadcrumbs];
    }
    setFinalBreadcrumbs(breadcrumbs);
  }, [pathname]);

  return <Breadcrumbs breadcrumbs={finalBreadcrumbs} />;
};

export default QuizBreadcrumbs;
